import { FormatType } from '../../types';
import { getFormatter } from '../../utilities';
import styles from './sankey-chart.module.css';
import { getSankeyNodeLabel, type SankeyRenderLink } from './types';

const percentFormat = getFormatter(FormatType.PERCENTAGE);

export const SankeyLinkTooltipContent = ({
  link,
  format,
}: {
  link: SankeyRenderLink;
  format: ReturnType<typeof getFormatter>;
}) => {
  const sourceLabel = getSankeyNodeLabel(link.source);
  const targetLabel = getSankeyNodeLabel(link.target);
  const share = link.displayShare;
  const showShare = share !== undefined && share > 0;
  const shareLabel = link.hubIsTarget ? 'Inflow share' : 'Outflow share';

  return (
    <div
      className={styles.tooltipBlock}
      data-testid="sankey-chart__path-tooltip"
    >
      <div className={styles.tooltipTitle}>
        {sourceLabel}
        <span className={styles.tooltipArrow} aria-hidden>
          →
        </span>
        {targetLabel}
      </div>
      <dl className={styles.tooltipMetrics}>
        <dt>Transitions</dt>
        <dd>{format(link.rawValue)}</dd>
        {showShare && (
          <>
            <dt>{shareLabel}</dt>
            <dd>{percentFormat(share)}</dd>
          </>
        )}
      </dl>
    </div>
  );
};
